import { PROPUP_EMAIL_DOMAINS } from '@shared/constants/side-panel-config.const';
import { PermissionLevelType } from '@shared/enums/permission-level.enum';
import { isUserEmailDomainAllowed } from '@shared/functions/check-user-email-domain';
import { UserData } from '@shared/interfaces/user-data';

export function checkPropupAdminPermissionLevel(userData: UserData): boolean {
  const permissionList = userData?.permissionLevel;
  if (!permissionList?.length) {
    return false;
  }

  if (
    isUserEmailDomainAllowed(userData.email, PROPUP_EMAIL_DOMAINS) &&
    permissionList.filter(value => value === PermissionLevelType.AllPermissions).length
  ) {
    return true;
  }

  return false;
}
